export default __webpack_public_path__ + "static/media/scan_white.3b9fd312.svg";